import { DatePipe } from '@angular/common';
import { PagamentoService } from 'administrativo-lib';
import { FuncaoService, Login, Relatorio } from 'eddydata-lib';

export class BoletimPagamento {

  protected datepipe: DatePipe;
  protected funcaoService: FuncaoService;
  protected pagtoService: PagamentoService;

  private log: Login;

  dataCaixa: Date;
  numero: number;
  tesoureiro: Responsavel;
  contador: Responsavel;
  prefeito: Responsavel;

  constructor() {
    this.funcaoService = new FuncaoService();
    this.datepipe = new DatePipe('pt');
  }

  public imprimir(lista: any[], login: Login) {
    this.log = login;

    Relatorio.imprimirPersonalizado('BOLETIM ANALÍTICO DE PAGAMENTO', login.usuario.nome,
      login.orgao.nome, login.brasao,
      this.montarConteudo(lista),
      'portrait', 'BOLETIM ANALÍTICO DE PAGAMENTO',
      {
        linhas: {
          hLineWidth() {
            return 1;
          },
          vLineWidth() {
            return 1;
          },
          hLineColor() {
            return 'black';
          },
          paddingLeft() {
            return 3;
          },
          paddingRight() {
            return 3;
          }
        }
      }, true);
  }

  private montarConteudo(lista: any[]) {

    const conteudo = [];

    conteudo.push(
      this.dadosCabecalho(this.log)
        .concat(this.dadosDetalhe(lista))
        .concat(this.dadosAssinatura(this.log))
    );
    return conteudo;
  }

  private dadosCabecalho(log: Login): {}[] {
    let brasaoImage: {};
    if (log.brasao) {
      brasaoImage = {
        image: log.brasao,
        width: 70,
        alignment: 'center',
        margin: [0, 30, 0, 0]
      };
    } else {
      brasaoImage = { margin: [0, 30, 0, 0], text: '' };
    }
    const conteudo = [
      [{ text: brasaoImage, border: [true, true, true, false] }],
      [{ text: log.orgao.nome, bold: true, alignment: 'center', fontSize: 13, border: [true, false, true, false] }],
      [{
        text: `BOLETIM ANALÍTICO DE PAGAMENTO Nº ${this.funcaoService.strZero(this.numero, 5)} `,
        bold: true, alignment: 'center', fontSize: 12, border: [true, false, true, false]
      }],
      [{
        text: `DATA: ${this.datepipe.transform(this.dataCaixa, 'dd/MM/yyyy')}`,
        alignment: 'center', fontSize: 12, border: [true, false, true, false]
      }]
    ];

    return [{
      layout: 'linhas',
      table: {
        dontBreakRows: true,
        widths: ['*'],
        body: conteudo
      }
    }];
  }

  private dadosDetalhe(dados: any): {}[] {
    const conteudo = [
      [
        { text: 'FICHA', rowSpan: 2, fontSize: 8, alignment: 'center', bold: true, margin: [0, 5, 0, 0] },
        { text: 'ESPECIFICAÇÃO', rowSpan: 2, fontSize: 8, alignment: 'center', bold: true, margin: [0, 5, 0, 0] },
        { text: 'ORÇADA', rowSpan: 2, fontSize: 8, alignment: 'center', bold: true, margin: [0, 5, 0, 0] },
        { text: 'PAGAMENTOS', colSpan: 2, fontSize: 8, alignment: 'center', bold: true },
        { text: '' },
        { text: 'DIFERENÇA', rowSpan: 2, fontSize: 8, alignment: 'center', bold: true, margin: [0, 5, 0, 0] },
      ],
      [
        { text: '' },
        { text: '' },
        { text: '' },
        { text: 'DO DIA', fontSize: 8, alignment: 'center', bold: true, colSpan: 1 },
        { text: 'ACUMULADA', fontSize: 8, alignment: 'center', bold: true },
        { text: '' },
      ]
    ];

    let totalOrcada = 0;
    let totalDia = 0;
    let totalAcumulada = 0;
    let totalDiferenca = 0;
    for (const item of dados) {

      if (+item['pago_mes'] + +item['pago_acumulado'] > 0) {
        const diferenca = +item['fh_valor_orcado'] - (+item['pago_mes'] + +item['pago_acumulado']);
        totalOrcada += +item['fh_valor_orcado'];
        totalDia += +item['pago_mes'];
        totalAcumulada += +item['pago_acumulado'];
        totalDiferenca += +diferenca;
        conteudo.push(
          [
            { text: this.funcaoService.strZero(item['fh_numero'], 4), fontSize: 8, alignment: 'center', bold: false },
            { text: item['d_codigo'] + ' ' + item['d_nome'] },
            { text: this.funcaoService.convertToBrNumber(item['fh_valor_orcado']), fontSize: 8, alignment: 'right', bold: false },
            { text: this.funcaoService.convertToBrNumber(item['pago_mes']), fontSize: 8, alignment: 'right', bold: false },
            { text: this.funcaoService.convertToBrNumber(item['pago_acumulado']), fontSize: 8, alignment: 'right', bold: false },
            { text: this.funcaoService.convertToBrNumber(diferenca), fontSize: 8, alignment: 'right', bold: false },
          ]
        );
      }
    }

    conteudo.push(
      [
        { text: 'TOTAL', colSpan: 2, fontSize: 9, alignment: 'left', bold: true },
        { text: '' },
        { text: this.funcaoService.convertToBrNumber(totalOrcada), fontSize: 9, alignment: 'right', bold: true },
        { text: this.funcaoService.convertToBrNumber(totalDia), fontSize: 9, alignment: 'right', bold: true },
        { text: this.funcaoService.convertToBrNumber(totalAcumulada), fontSize: 9, alignment: 'right', bold: true },
        { text: this.funcaoService.convertToBrNumber(totalDiferenca), fontSize: 9, alignment: 'right', bold: true },
      ]
    );

    return [{
      layout: 'linhas',
      table: {
        dontBreakRows: true,
        headerRows: 2,
        widths: [30, '*', 60, 60, 60, 60],
        body: conteudo
      }
    }];
  }

  private dadosAssinatura(log: Login): {}[] {
    const conteudo = [
      [
        {
          text: '__________________________________________', alignment: 'center',
          border: [false, false, false, false], margin: [0, 30, 0, 0]
        },
        {
          text: '__________________________________________', alignment: 'center',
          border: [false, false, false, false], margin: [0, 30, 0, 0]
        },
        {
          text: '__________________________________________', alignment: 'center',
          border: [false, false, false, false], margin: [0, 30, 0, 0]
        }
      ],
      [
        { text: this.tesoureiro ? this.tesoureiro.nome : '', alignment: 'center', border: [false, false, false, false] },
        { text: this.contador ? this.contador.nome : '', alignment: 'center', border: [false, false, false, false] },
        { text: this.prefeito ? this.prefeito.nome : '', alignment: 'center', border: [false, false, false, false] }
      ],
      [
        { text: this.tesoureiro ? this.tesoureiro.cargo : '', alignment: 'center', border: [false, false, false, false] },
        { text: this.contador ? this.contador.cargo : '', alignment: 'center', border: [false, false, false, false] },
        { text: this.prefeito ? this.prefeito.cargo : '', alignment: 'center', border: [false, false, false, false] }
      ],
    ];

    return [{
      layout: 'linhas',
      table: {
        dontBreakRows: true,
        heights: [10, 0],
        widths: ['*', '*', '*'],
        body: conteudo
      }
    }];
  }

}

class Responsavel {
  nome: string;
  cargo: string;
}
